import ptbrLang from 'element-ui/lib/locale/lang/pt-br'
const messages = {
  ...ptbrLang,
  "banner1": "A marca Solplanet é um desenvolvimento da AISWEI",
  "banner2": "anteriormente SMA China",
  "banner3": "Solar para todos",
  "english": "Inglês",
  "polish": "Polonês",
  "spanish": "Espanhol",
  "turkish": "Turco",
  "germany": "Alemão",
  "french": "Francês",
  "italian": "Italiano",
  "systemData1": "Sistema",
  "installationLocation1": "Instalação",
  "customerData1": "Cliente",
  "claimData": "Reclamação",
  "shippingAddress1": "Envio",
  "customerData": "Cliente / Dados do cliente",
  "customerType": "Tipo de solicitante",
  "selectCustomer": "Selecione o tipo de solicitante",
  "--None--": "--Nenhum--",
  "Installer": "Instaladores",
  "End-customer": "Usuário final",
  "Distributor": "Distribuidor",
  "EPC": "EPC",
  "Other": "Outros",
  "companyName": "Nome da empresa",
  "typeCompanyName": "Por favor insira o nome da empresa",
  "contacts": "Nome do contato",
  "typeContacts": "Por favor, insira o nome do contato",
  "contactInformation": "Número de telefone",
  "typeContactInformation": "Por favor, insira o número do telefone",
  "shippingAddress": "Endereço de entrega (observe que este endereço servirá como endereço de entrega no caso de uma troca.)",
  "country": "País/Região",
  "typeCountry": "Por favor,insira o país/região",
  "province": "Estado",
  "typeProvince": "Por favor, insira o estado",
  "city": "Cidade",
  "typeCity": "Por favor, insira a cidade",
  "area": "Rua",
  "typeArea": "Insira o endereço completo (até o número da casa)",
  "contacts01": "Celular",
  "typeContacts01": "Por favor, insira o telefone celular",
  "postCode": "Código postal",
  "typePostCode": "Por favor insira o código postal",
  "email": "Email",
  "typeEmail": "Por favor insira o email",
  "errorEmail": "Por favor insira o endereço de e-mail válido.",
  "CNPJ": "CNPJ/CPF",
  "typeCNPJ": "Por favor insira o CNPJ/CPF",
  "IE": "IE(Inscrição Estadual)",
  "typeIE": "Por favor insira o IE(Inscrição Estadual)",
  "installationLocation": "Local de instalação (use o endereço de entrega)",
  "purchaseDate": "Data de compra",
  "typePurchaseDate": "Por favor, insira a data de compra",
  "installDate": "Data de Instalação",
  "typeInstallDate": "Por favor, insira a data de instalação",
  "faultyDeviceType": "Tipo de dispositivo defeituoso",
  "selectFaultyDeviceType": "Selecione o tipo de dispositivo com defeito",
  "faultDate": "Data da Falha",
  "typeFaultDate": "Por favor, insira a data da falha",
  "deviceSerialNumber": "Número de série do dispositivo",
  "typeDeviceSerialNumber": "Por favor, insira o número de série do dispositivo",
  "faultySymptom": "Sintoma defeituoso",
  "selectFaultySymptom": "Selecione o sintoma defeituoso",
  "errorDescription": "Descrição detalhada do erro",
  "typeErrorDescription": "Digite a descrição detalhada do erro",
  "purchaseFileId": "Comprovante de compra (anexo)",
  "purchaseDesc": "O comprovante de compra deve incluir o nome do cliente, o modelo do inversor, endereço de instalação e o comprovante de pagamento.",
  "breakFileId": "Certificado de falha (anexo)",
  "breakDesc": "Envie uma foto do detalhe do defeito, a mensagem de erro e o adesivo com o número de série do produto",
  "upload": "Envio",
  "systemData": "Dados do sistema (opcional)",
  "systemData01": "É a primeira reclamação deste local?",
  "Yes": "sim",
  "No": "Não",
  "Unknown": "Desconhecido",
  "systemData02": "Status operacional de outros inversores do mesmo local",
  "systemData03": "Motivo da reclamação anterior",
  "enterSystemData03": "Insira o motivo da reclamação anterior",
  "systemData04": "Detalhe da falha de outros inversores no mesmo local",
  "enterSystemData04": "Por favor, insira os detalhes da falha de outros inversores no mesmo local",
  "systemData05": "Condições ambientais da instalação do inversor",
  "systemData0501": "Interior",
  "systemData0502": "Ao ar livre (sob a sombra do edifício ou coberto)",
  "systemData0503": "Externo (expondo o inversor à luz solar direta)",
  "systemData0504": "Sobre a água",
  "systemData0505": "Outros",
  "systemData06": "Condições ambientais de instalação de painéis solares",
  "systemData0601": "No chão",
  "systemData0602": "No telhado",
  "systemData0603": "Na superfície da água",
  "systemData0604": "Outros",
  "systemData07": "Marca e modelo do painel solar",
  "typeSystemData07": "Insira a marca e o modelo do painel solar",
  "systemData08": "Modo PV",
  "systemData0801": "Independente",
  "systemData0802": "Paralelo",
  "pleaseSelect": "Por favor selecione",
  "add": "Adicionar",
  "delete": "Excluir",
  "pv10": "painel solar string (peças)",
  "pv101": "Painel solar PV1string (peças)",
  "pv102": "Painel solar PV2string (peças)",
  "pv103": "Painel solar PV3string (peças)",
  "pv104": "Painel solar PV4string (peças)",
  "circuit01": "tensão de circuito aberto (V)",
  "alternatingVoltage": "Tensão Alternada",
  "l1l2": "Tensão AC L1 - L2 (V)",
  "l1n": "Tensão AC L1 - N (V)",
  "l2l3": "Tensão AC L2 - L3 (V)",
  "l2n": "Tensão AC L2 - N (V)",
  "l1l3": "Tensão AC L1 - L3 (V)",
  "l3n": "Tensão AC L3 - N (V)",
  "l1pe": "Tensão AC L1 - PE (V)",
  "l3pe": "Tensão AC L3 - PE (V)",
  "l2pe": "Tensão AC L2 - PE (V)",
  "npe": "Tensão AC N - PE (V)",
  "complaintFileId": "Acessório",
  "activeTip": "Aviso: Quanto mais informações detalhadas da instalação você puder fornecer, mais rápido podemos identificar o problema.",
  "submitBtn": "Enviar",
  "pleaseType": "Por favor, insira",
  "submitSuccess": "Sucesso de envio",
  "submitDesc": "Alguns campos obrigatórios não foram preenchidos, reenvie após a confirmação. Obrigado!",
  "typeUpload": "Por favor carregue",
  "resetUpload": "Carregar novamente",
  "selectErrorMessage": "Selecione a mensagem de erro",
  "errorMessage": "Outros",
  "MPPT": "MPPT",
  "chinese": "Chinês",
  "dutch": "Holandês",
  "hungary": "Húngaro",
  "termswebsite": "https://solplanet.net/privacy/",
  "terms": "Eu concordo com os termos e condições do Solplanet",
  "iagree": "Eu concordo com os termos e condições do Solplanet",
  "language": "Idioma",
  "ptbr": "Português",
  "zhtw": "Chinês tradicional",
  "documentTitle": "Garantia │Solplanet",
  "validateNumber": "Digite um número inteiro"
}
export default messages



// WEBPACK FOOTER //
// ./src/widgets/i18n/pt-BR.js